import React, { useState } from 'react';
import cx from 'classnames';
import { Link } from 'gatsby';

const ProcessStep = ({ title, items, className, icon, link, isOpenDefault = false }) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={cx('ProcessStep', { isOpen })} onClick={toggle}>
      <div className={`ProcessStep__stripe ${className}`} />
      <div className="ProcessStep__body">
        <div className="ProcessStep__icon">
          <img src={icon} alt="" />
        </div>

        <h3 className="ProcessStep__title">{title}</h3>

        {isOpen && <i className="ProcessStep__chevron far fa-chevron-down" />}
        {!isOpen && <i className="ProcessStep__chevron far fa-chevron-right" />}

        <ul className="ProcessStep__list">
          {items.map((item, idx) => (
            <li className="ProcessStep__item" key={idx}>
              <i className="far fa-check" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="ProcessStep__link">
          <Link to={link}>Learn more</Link>
        </div>
      </div>
    </div>
  );
};

export default ProcessStep;
